import React, { useEffect, useState } from 'react';
import { Disc3 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function RenderCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${API}/api/stats/renders`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (active && data) setCount(data.count);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (count === null) return null;

  return (
    <p className="text-xs text-neutral-400 flex items-center gap-1.5" data-testid="render-counter">
      <Disc3 className="w-3.5 h-3.5" />
      {count.toLocaleString()} spinning-disc videos made with Waxify so far
    </p>
  );
}
